import { PanBottomRightIcon } from './PanBottomRightIcon';

/**
 * author: Simran
 * id BAAF741C-C242-49A8-8A16-DA1EC373385D
 * name pan-bottom-right
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-bottom-right.svg
 * tags
 */
export const PanDownRightIcon = PanBottomRightIcon;
export default PanDownRightIcon